import { useSettings } from '@wix/tpa-settings/react';
import { dashify } from '../utils/guid';
import settingsParams from '../../../settingsParams';

export function useChannelId(): string {
  const settings = useSettings();
  return dashify(settings.get(settingsParams.channelId)) || '';
}
